import { email, required, requiredIf } from 'vuelidate/lib/validators';
import phone from '@/validators/rule/phone';
import bicCode from '@/validators/rule/bicCode';
import checkingAccountIBAN from '@/validators/rule/checkingAccountIBAN';
import name from '@/validators/rule/name';

export default {
  firstName: {
    required,
    name
  },
  lastName: {
    required,
    name
  },
  thirdName: {
    required,
    name
  },
  legalAddress: {
    required
  },
  checkingAccountIBAN: {
    checkingAccountIBAN
  },
  bankBicCode: {
    required: requiredIf((project) => {
      return project.checkingAccountIBAN !== '';
    }),
    bicCode
  },
  bankName: {
    required: requiredIf((project) => {
      return project.checkingAccountIBAN !== '';
    })
  },
  bankAddress: {
    required: requiredIf((project) => {
      return project.checkingAccountIBAN !== '';
    })
  },
  phone: {
    required,
    phone
  },
  email: {
    required,
    email
  }
}
